export default {"src":"/_next/static/media/LogoIpsum3.04170d10.svg","height":32,"width":185,"blurWidth":0,"blurHeight":0};